<template>
    <div class="container remove-padding-margin">
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1">
                    <div class="text-alignC mar-top-144"><img src="../../assets/img/iconWA.svg" alt=""></div>
                    <div class="font-16 font-weight-600 color-0000 line-height-25 letter-space-002 text-center mar-top-40">Nomor WA Berhasil Diubah</div>
                    <div class="color-8080 text-center letter-space-002 line-height-21 font-14">Login Nomor WA Anda sekarang menjadi<br>{{telp}}</div>
                </div>
                <div>
                    <div class="button-lanjut">
                        <button class="btn btn-login btn-long" id="btnsuccess" @click="back">
                            <span id="textbtnsuccess">Oke</span>
                        </button>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    export default {
        name: "SuccessChangeWA",
        data(){
            return{
                telp:'',
                isClicked:false,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
        mounted(){
            var telpLocal = "+" + localStorage.getItem("telp");
            this.telp = telpLocal;
        },
        methods:{
            back(){
                this.$router.push('/loginownerwa')
            },
        }
    }
</script>

<style scoped>

</style>